import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const reminderSettingsApi = createApi({
  reducerPath: "reminderSettingsApi",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["ReminderSettings"],
  endpoints: (builder) => ({
    // 🔹 Get Reminder Settings
    getReminderSettings: builder.query({
      query: () => ({
        url: `/contractor/reminder_settings`,
        method: "GET",
      }),
      providesTags: ["ReminderSettings"],
    }),

    // 🔹 Update Reminder Settings
    updateReminderSettings: builder.mutation({
      query: ({ data }) => ({
        url: `/contractor/reminder_settings`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ReminderSettings"],
    }),
  }),
});

// ✅ Export hooks
export const {
  useGetReminderSettingsQuery,
  useUpdateReminderSettingsMutation,
} = reminderSettingsApi;
